
import { Component, Inject, Vue } from "vue-property-decorator";
import FormTextarea from "../../../landing/src/molecules/form/FormTextarea.vue";
import { Container } from "inversify";
import { NotificationStore } from "../stores/NotificationStore";
import { focusOnFirstInvalidInput } from "../form/utils";
import ActionButton from "../components/ActionButton.vue";
import Modal from "../components/Modal.vue";
import { SubscriptionQuoteModalStore } from "./SubscriptionQuoteModalStore";
import { SubmitSubscriptionQuoteStore } from "./SubmitSubscriptionQuoteStore";
import RecaptchaDisclosure from "../../../landing/src/molecules/recaptcha/RecaptchaDisclosure.vue";
import FormInput from "../../../landing/src/molecules/form/FormInput.vue";
import FormTel from "../../../landing/src/molecules/form/FormTel.vue";

@Component({
    components: {
        FormTel,
        FormInput,
        RecaptchaDisclosure,
        ActionButton,
        Modal,
        FormTextarea,
    },
})
export default class SubscriptionQuoteModal extends Vue {
    @Inject("container") readonly container!: Container;
    readonly notificationStore: NotificationStore = this.container.get(NotificationStore);
    readonly submitStore: SubmitSubscriptionQuoteStore = this.container.get(
        SubmitSubscriptionQuoteStore,
    );
    readonly modalStore: SubscriptionQuoteModalStore = this.container.get(
        SubscriptionQuoteModalStore,
    );

    get values() {
        return this.submitStore.data;
    }

    get errors() {
        return this.submitStore.formErrors;
    }

    get title() {
        if (this.modalStore.isGsx) {
            return "Request GSE membership subscription quote";
        }
        return "Request Quilty membership subscription quote";
    }

    async submit() {
        if (this.modalStore.isGsx) {
            this.submitStore.data.subscription = "Global Space Exchange";
        } else {
            this.submitStore.data.subscription = "Quilty";
        }

        await this.submitStore.submit();

        if (this.submitStore.failed) {
            this.notificationStore.warning("Request has failed.");
            focusOnFirstInvalidInput();
        } else {
            this.notificationStore.success(
                "You have requested for a subscription quote successfully.",
            );
            this.modalStore.close();
        }
    }
}
